import { type OperatorType } from 'features/charts-v2/components/KeywordOperatorPopover'

// Canonical keyword-operator list — the single source KeywordOperatorPopover
// and the in-popover Keywords pane derive their options from.
export const KEYWORD_OPERATORS: readonly OperatorType[] = [
  'Includes all',
  'Includes some',
  'Excludes some',
  'Excludes all',
]
